import { Delivery, DeliveryOrder } from "./types"

export enum ActionType {
    UPDATE_DELIVERY_ORDERS = 'updateDeliveryOrders',
    REMOVE_DELIVERY_ORDERS = 'removeDeliveryOrders',
    UPDATE_DELIVERIES = 'updateDeliveries',
    REMOVE_DELIVERIES = 'removeDeliveries'
}

interface UpdateDeliveryOrders {
    type: ActionType.UPDATE_DELIVERY_ORDERS
    payload: DeliveryOrder[]
}

interface RemoveDeliveryOrders {
    type: ActionType.REMOVE_DELIVERY_ORDERS
    payload: string[]
}

interface UpdateDeliveries {
    type: ActionType.UPDATE_DELIVERIES
    payload: Delivery[]
}

interface RemoveDeliveries {
    type: ActionType.REMOVE_DELIVERIES
    payload: string[]
}

export type DeliveriesAction =
    DeliveriesUpdateAction |
    DeliveriesRemoveAction

export type DeliveriesUpdateAction =
    UpdateDeliveryOrders |
    UpdateDeliveries

export type DeliveriesRemoveAction =
    RemoveDeliveryOrders |
    RemoveDeliveries
